<template lang="pug">
DropdownCheckboxes(
  :label="label"
  :name="name"
  :options="sectionOptions"
  :value="value"
  @input="update"
  :loading="loading"
)
</template>

<script>
  import DropdownCheckboxes from '../dropdown_checkboxes.vue'

  export default {
    components: {
      DropdownCheckboxes
    },

    props: {
      label: {
        type: String,
        default() { return 'Section' }
      },

      name: {
        type: String,
        default() { return 'q[story_sections_section_id_in][]' }
      },

      value: {
        type: Array,
        default() { return [] }
      }
    },

    computed: {
      sectionOptions() {
        return this.$store.getters['sections/enabledAsObject'];
      },

      loading() {
        return this.$store.getters['sections/all'].length === 0;
      }
    },

    mounted() {
      this.$store.dispatch('sections/fetch');
    },

    methods: {
      update(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
</script>
